import React from 'react'
import { Link } from 'gatsby'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import SEO from '../components/seo'

class NotFoundPage extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="404: Not Found" />
        <article className="max-width-40-rem">
          <h1>not found ╥﹏╥</h1>
          <blockquote>
            I looked at him like a stranger, someone I’d never seen before, and
            he looked at me like I’d been lost to him for a thousand years and
            finally found.
          </blockquote>
          <small>― Emme Rollins, Dear Rockstar</small>
          <p>
            <Link to="/">And let's go back home.</Link>
          </p>
        </article>
      </Layout>
    )
  }
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
